import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-exam-form-report-collegewise',
  templateUrl: './exam-form-report-collegewise.component.html',
  styleUrls: ['./exam-form-report-collegewise.component.scss']
})
export class ExamFormReportCollegewiseComponent implements OnInit {
  ExamFormReport: FormGroup;
  UserCollege: any;
  userPermission: any;

  fcCodeList: any[];
  filteredListFcCode: any[];

  CourseList: any[];
  filteredCourseList: any[];

  collegeList: any[];
  filteredCollegeList: any[];

  ExamAList: any[];
  filteredExamAList: any[];

  isBranch = false;
  BranchList: any[];
  filteredBranchList: any[];

  sessionList: any[];
  SessionFilterList: any[];

  Table = false;
  ExamFormStudentList: any;
  filteredExamFormStudentList: any;
  TotalAllStudents: any;
  TotalExamSubmittedRecords: any;

  isAllCollegesSelected = false;
  isAllCoursesSelected = false;
  isAllExamsSelected = false;
  isAllBranchesSelected = false;

  // Flag to prevent multiple API calls
  private isApiCalling = false;
  private readonly DEBOUNCE_TIME = 300;

  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.ExamFormReport = this.fb.group({
      SessionId: new FormControl(''),
      Faculty: new FormControl(''),
      course: new FormControl([]),
      college: new FormControl([]),
      Exam: new FormControl([]),
      Branch: new FormControl([])
    });

    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    if (this.userPermission && this.userPermission.length > 0) {
      this.UserCollege = this.userPermission[0].CgUi === 'C' ? this.userPermission[0].CgId : '';
    } else {
      this.UserCollege = '';
    }

    this.fetchSession('');
    this.fetchFaculty();

    // Setup form value listeners
    this.setupFormValueListeners();
  }

  private setupFormValueListeners() {
    this.ExamFormReport.valueChanges
      .pipe(
        debounceTime(this.DEBOUNCE_TIME),
        distinctUntilChanged((prev, curr) => {
          return JSON.stringify({
            SessionId: prev.SessionId,
            Faculty: prev.Faculty,
            course: prev.course?.slice().sort(),
            college: prev.college?.slice().sort(),
            Exam: prev.Exam?.slice().sort(),
            Branch: prev.Branch?.slice().sort()
          }) === JSON.stringify({
            SessionId: curr.SessionId,
            Faculty: curr.Faculty,
            course: curr.course?.slice().sort(),
            college: curr.college?.slice().sort(),
            Exam: curr.Exam?.slice().sort(),
            Branch: curr.Branch?.slice().sort()
          });
        })
      )
      .subscribe(formValues => {
        // Check if we have all required selections
        const hasRequiredSelections = 
          formValues.SessionId &&
          formValues.Faculty &&
          formValues.course?.length > 0 &&
          formValues.college?.length > 0 &&
          formValues.Exam?.length > 0;

        if (hasRequiredSelections) {
          // Check if branch is required for any selected exam
          const examRequiresBranch = this.ExamAList.some(exam => 
            formValues.Exam.includes(exam.EmId) && exam.EmStreams === 'Y'
          );
          
          if (examRequiresBranch && (!formValues.Branch || formValues.Branch.length === 0)) {
            // Branch is required but not selected yet
            return;
          }

          // Call API with all selected values as comma-separated string
          this.getExamFormStudent();
        } else {
          // Clear table when selections are incomplete
          this.clearStudents();
        }
      });
  }

  fetchSession(id: string) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus === 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    });
  }

  fetchFaculty() {
    this.umsService.getFaculty({}).subscribe(res => {
      if (res.status) {
        this.fcCodeList = res.data || [];
        this.filteredListFcCode = [...this.fcCodeList];
      }
    });
  }

  onFacultyChange(fcCode: string) {
    this.clearCoursesAndExams();
    this.ExamFormReport.patchValue({ 
      course: [], 
      college: [], 
      Exam: [], 
      Branch: [] 
    }, { emitEvent: false });
    this.isBranch = false;
    this.BranchList = [];
    this.filteredBranchList = [];
    this.isAllBranchesSelected = false;

    if (fcCode) {
      this.fetchCourses(fcCode);
    }
  }

  fetchCourses(fcCode: string) {
    const sessionId = this.ExamFormReport.value.SessionId;
    if (!sessionId) {
      this.CourseList = [];
      this.filteredCourseList = [];
      return;
    }

    const payload = {
      FcCode: fcCode,
      SessionID: sessionId
    };
    this.umsService.getCourses(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data || [];
        this.filteredCourseList = [...this.CourseList];
      } else {
        this.CourseList = [];
        this.filteredCourseList = [];
      }
    }, () => {
      this.CourseList = [];
      this.filteredCourseList = [];
    });
  }

  onCourseChange() {
    this.clearExamsAndStudents();
    this.ExamFormReport.patchValue({ 
      college: [], 
      Exam: [], 
      Branch: [] 
    }, { emitEvent: false });
    this.isBranch = false;
    this.BranchList = [];
    this.filteredBranchList = [];
    this.isAllBranchesSelected = false;

    const selectedCourses = this.ExamFormReport.value.course;
    if (!selectedCourses || selectedCourses.length === 0) {
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.ExamAList = [];
      this.filteredExamAList = [];
      return;
    }

    this.fetchColleges(selectedCourses);
    this.fetchExams(selectedCourses);
  }

  // Fetch colleges without forkJoin - sequential calls
  fetchColleges(selectedCourses: string[]) {
    const sessionId = this.ExamFormReport.value.SessionId;
    const fcCode = this.ExamFormReport.value.Faculty;
    
    if (!sessionId || !fcCode || selectedCourses.length === 0) {
      this.collegeList = [];
      this.filteredCollegeList = [];
      return;
    }

    let allColleges = [];
    let completedCalls = 0;
    const totalCalls = selectedCourses.length;

    selectedCourses.forEach(coCode => {
      const payload = {
        CoCode: coCode,
        FcCode: fcCode,
        SessionID: sessionId
      };
      
      this.umsService.getCollegeFaculty(payload).subscribe(
        res => {
          if (res.status && res.data) {
            allColleges = allColleges.concat(res.data);
          }
          
          completedCalls++;
          
          // Process results after all calls complete
          if (completedCalls === totalCalls) {
            // Remove duplicates
            const uniqueMap = new Map();
            allColleges.forEach(college => {
              if (!uniqueMap.has(college.CgCode)) {
                uniqueMap.set(college.CgCode, college);
              }
            });
            
            let colleges = Array.from(uniqueMap.values());
            
            // Filter by user college if needed
            if (this.UserCollege) {
              colleges = colleges.filter(c => c.CgCode === this.UserCollege);
            }
            
            this.collegeList = colleges;
            this.filteredCollegeList = [...this.collegeList];
          }
        },
        error => {
          console.error('Error fetching college:', error);
          completedCalls++;
          
          // Still process results even if some calls fail
          if (completedCalls === totalCalls) {
            const uniqueMap = new Map();
            allColleges.forEach(college => {
              if (!uniqueMap.has(college.CgCode)) {
                uniqueMap.set(college.CgCode, college);
              }
            });
            
            let colleges = Array.from(uniqueMap.values());
            
            if (this.UserCollege) {
              colleges = colleges.filter(c => c.CgCode === this.UserCollege);
            }
            
            this.collegeList = colleges;
            this.filteredCollegeList = [...this.collegeList];
          }
        }
      );
    });
  }

  fetchExams(selectedCourses: string[]) {
    if (!selectedCourses || selectedCourses.length === 0) {
      this.ExamAList = [];
      this.filteredExamAList = [];
      return;
    }

    const payload = { EmCoCode: selectedCourses.join(',') };
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.ExamAList = res.data || [];
        this.filteredExamAList = [...this.ExamAList];
      } else {
        this.ExamAList = [];
        this.filteredExamAList = [];
      }
    }, () => {
      this.ExamAList = [];
      this.filteredExamAList = [];
    });
  }

  onExamChange() {
    this.clearStudents();
    this.ExamFormReport.patchValue({ 
      Branch: [] 
    }, { emitEvent: false });
    this.isBranch = false;
    this.BranchList = [];
    this.filteredBranchList = [];
    this.isAllBranchesSelected = false;

    const selectedExams = this.ExamFormReport.value.Exam;
    if (!selectedExams || selectedExams.length === 0) return;

    const examWithStream = this.ExamAList.find(exam =>
      selectedExams.includes(exam.EmId) && exam.EmStreams === 'Y'
    );

    if (examWithStream) {
      this.isBranch = true;
      this.fetchBranches(examWithStream.EmId);
    }
  }

  fetchBranches(emId: number) {
    const payload = { EmId: emId };
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data || [];
        this.filteredBranchList = [...this.BranchList];
        this.isBranch = true;
      } else {
        this.isBranch = false;
        this.BranchList = [];
        this.filteredBranchList = [];
      }
    }, () => {
      this.isBranch = false;
      this.BranchList = [];
      this.filteredBranchList = [];
    });
  }

  // MAIN API CALL - Single call with all comma-separated values
  getExamFormStudent() {
    // Prevent multiple simultaneous calls
    if (this.isApiCalling) {
      return;
    }

    const formValues = this.ExamFormReport.value;
    const selectedColleges = formValues.college;
    const selectedCourses = formValues.course;
    const selectedExams = formValues.Exam;
    const selectedBranches = formValues.Branch;
    const facultyCode = formValues.Faculty || '';

    // Validate selections
    if (!selectedColleges?.length || !selectedCourses?.length || !selectedExams?.length) {
      this.clearStudents();
      return;
    }

    // Check if branch is required but not selected
    const examRequiresBranch = this.ExamAList.some(exam =>
      selectedExams.includes(exam.EmId) && exam.EmStreams === 'Y'
    );
    if (examRequiresBranch && (!selectedBranches || selectedBranches.length === 0)) {
      return; // Wait for branch selection
    }

    const branchStr = selectedBranches && selectedBranches.length > 0
      ? selectedBranches.join(',')
      : '0';

    this.isApiCalling = true;
    this.spinner.show();

    // Build payload with comma-separated values
    const payload = {
      CgCode: selectedColleges.join(','),
      EmId: selectedExams.join(','),
      CoCode: selectedCourses.join(','),
      SessionCode: formValues.SessionId,
      StrId: branchStr,
      FcCode: facultyCode,
      SearchString: '',
      PageNo: '',
      PageSize: ''
    };

    // SINGLE API CALL with all comma-separated values
    this.umsService.getExamFormClgwise(payload).subscribe(
      res => {
        this.isApiCalling = false;
        this.spinner.hide();
        
        if (res.status) {
          this.Table = true;
          this.ExamFormStudentList = res.data;
          this.filteredExamFormStudentList = this.ExamFormStudentList.slice();
          this.TotalAllStudents = res.data[0]?.TotalAllStudents || 0;
          this.TotalExamSubmittedRecords = res.data[0]?.TotalRecords || 0;
        } else {
          this.clearStudents();
        }
      },
      error => {
        this.isApiCalling = false;
        this.spinner.hide();
        this.clearStudents();
        console.error('Error fetching exam form data:', error);
      }
    );
  }

  downloadTeacherData() {
    this.spinner.show();

    const formValues = this.ExamFormReport.value;
    const selectedColleges = formValues.college;
    const selectedCourses = formValues.course;
    const selectedExams = formValues.Exam;
    const selectedBranches = formValues.Branch;
    const facultyCode = formValues.Faculty || '';

    if (!selectedColleges?.length || !selectedCourses?.length || !selectedExams?.length) {
      alert('Please select at least one College, Course and Exam.');
      this.spinner.hide();
      return;
    }

    const branchStr = selectedBranches && selectedBranches.length > 0
      ? selectedBranches.join(',')
      : '0';

    const payload = {
      CgCode: selectedColleges.join(','),
      EmId: selectedExams.join(','),
      CoCode: selectedCourses.join(','),
      SessionCode: formValues.SessionId,
      StrId: branchStr,
      FcCode: facultyCode,
      SearchString: '',
      PageNo: '',
      PageSize: ''
    };

    this.umsService.getExamFormClgwise(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (!res.status || !res.data || res.data.length === 0) {
          alert('No student exam form report available to download!');
          return;
        }

        const allData = res.data;
        const selectedData = allData.map((t, index) => ({
          'Sr No': index + 1,
          'Student Name': t.RgName || '',
          'PRN No': t.RgNo || '',
          'Exam': t.ExamName || ''
        }));

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(selectedData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Student Exam Form Report': worksheet },
          SheetNames: ['Student Exam Form Report']
        };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        });
        saveAs(data, 'Student_Exam_Form_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx');
      },
      error => {
        this.spinner.hide();
        console.error('Error downloading student exam form report:', error);
        alert('Something went wrong while downloading data!');
      }
    );
  }

  toggleSelectAllColleges() {
    if (this.isAllCollegesSelected) {
      this.ExamFormReport.patchValue({ college: [] }, { emitEvent: true });
    } else {
      const allCodes = this.filteredCollegeList.map(item => item.CgCode);
      this.ExamFormReport.patchValue({ college: allCodes }, { emitEvent: true });
    }
    this.isAllCollegesSelected = !this.isAllCollegesSelected;
  }

  toggleSelectAllCourses() {
    if (this.isAllCoursesSelected) {
      this.ExamFormReport.patchValue({ course: [] }, { emitEvent: true });
    } else {
      const allCodes = this.filteredCourseList.map(item => item.CoCgCoCode);
      this.ExamFormReport.patchValue({ course: allCodes }, { emitEvent: true });
    }
    this.isAllCoursesSelected = !this.isAllCoursesSelected;
    // onCourseChange will be called automatically due to valueChanges
    // But we need to manually call it for side effects
    this.onCourseChange();
  }

  toggleSelectAllExams() {
    if (this.isAllExamsSelected) {
      this.ExamFormReport.patchValue({ Exam: [] }, { emitEvent: true });
    } else {
      const allCodes = this.filteredExamAList.map(item => item.EmId);
      this.ExamFormReport.patchValue({ Exam: allCodes }, { emitEvent: true });
    }
    this.isAllExamsSelected = !this.isAllExamsSelected;
    this.onExamChange();
  }

  toggleSelectAllBranches() {
    if (this.isAllBranchesSelected) {
      this.ExamFormReport.patchValue({ Branch: [] }, { emitEvent: true });
    } else {
      const allCodes = this.filteredBranchList.map(item => item.StrId);
      this.ExamFormReport.patchValue({ Branch: allCodes }, { emitEvent: true });
    }
    this.isAllBranchesSelected = !this.isAllBranchesSelected;
  }

  private clearCoursesAndExams() {
    this.CourseList = [];
    this.filteredCourseList = [];
    this.clearExamsAndStudents();
  }

  private clearExamsAndStudents() {
    this.ExamAList = [];
    this.filteredExamAList = [];
    this.clearStudents();
  }

  private clearStudents() {
    this.Table = false;
    this.ExamFormStudentList = [];
    this.filteredExamFormStudentList = [];
    this.TotalAllStudents = 0;
    this.TotalExamSubmittedRecords = 0;
  }
}